import { Injector } from "@angular/core";
import { GridActionHandlerBase } from "../../../../../../components/common/grid-base/actions/grid-action-handler-base";
import { WorkspaceBase } from "../../../../../../components/common/workspace-base/workspace-base";
import { AppStorageService } from "../../../../../../services/app-storage.service";
import { ReportDesignerStorageService } from "../../../../../report-designer/services/report-designer-storage.service";

/**
 * Copies a Valuation Event
 */
export class OpenReportGridActionHandler extends GridActionHandlerBase {
  /**
   * AppStorageService
   */
  private appStorage: AppStorageService;

  /**
   * ReportDesignerStorageService
   */
  private rdStorage: ReportDesignerStorageService;

  /**
   * Constructor
   * @param injector Ihe Angular injector
   * @param workspace The workspace in which the action should be performed
   */
  constructor(injector: Injector,
    workspace: WorkspaceBase) {
    super(injector, workspace, 'openReportInNewTabClick');
    this.appStorage = injector.get(AppStorageService);
    this.rdStorage = injector.get(ReportDesignerStorageService);
  }

  /**
  * Handles an event
  * @param _payload The (untyped) payload. Can also be a callback function
  */
  public handle(_payload: any): void {
    const selectedItem = this.workspace.grid.selectedItem;
    if (selectedItem) {
      this.rdStorage.setReport(selectedItem.Oid);
      this.appStorage.setActiveValuationPortfolio({ oid: selectedItem.ValuationProjectId, description: selectedItem.ValuationProjectDescription });

      if (!selectedItem.HasCurrencyConversionRate) {
        this.eventBus.broadcastEvent("openConfirmDialog", {
          customMessage: () => { return `Please enter an exchange rate for the currency pair ${selectedItem.LocalCurrencyDescription} - ${selectedItem.ReportCurrencyDescription} for this Valuation Event` },
          success: () => {
            //Nothing
          }
        }, 'warrningMessageNoConversionRate');
      }
      else {
        const absUrl = document.location.href;//http://localhost/polluxApp/polluxValuation/app/pollux.html#/pd
        let url = absUrl.split("#")[0];//http://localhost/polluxApp/polluxValuation/app/pollux.html

        url += "#/rd";
        url += "?QuickViewReportId=" + selectedItem.Oid;//http://localhost/polluxApp/polluxValuation/app/pollux.html#/rd?QuickViewReportId=1216

        const openedWindow = window.open(url, '_blank');
        if (!openedWindow) {
          alert("Failed to open the Report Designer because the new tab was blocked. Please check your browser's settings!");
        }
      }
    }
  }
}
